var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93359 21.6484H20.0702V25.9631H9.93359V21.6484Z",
    fill: "#737AE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93359 21.6484H20.0702V25.9631H9.93359V21.6484Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.88296 0.5H29.117C29.6046 0.5 30 0.895209 30 1.38296V21.4567C30 21.9442 29.6048 22.3396 29.117 22.3396H0.88296C0.395409 22.3396 0 21.9444 0 21.4567V1.38296C0 0.895209 0.395209 0.5 0.88296 0.5Z",
    fill: "#737AE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.88296 0.5H29.117C29.6046 0.5 30 0.895209 30 1.38296V21.4567C30 21.9442 29.6048 22.3396 29.117 22.3396H0.88296C0.395409 22.3396 0 21.9444 0 21.4567V1.38296C0 0.895209 0.395209 0.5 0.88296 0.5Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80273 2.18066H28.2044V18.8115H1.80273V2.18066Z",
    fill: "#E8E8E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69971 25.3906H24.3032V27.341H5.69971V25.3906Z",
    fill: "#737AE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69971 25.3906H24.3032V27.341H5.69971V25.3906Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21875 5.32031V16.3803H16.1175V16.011H4.58451V5.32031H4.21875Z",
    fill: "#737AE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21875 5.32031V16.3803H16.1175V16.011H4.58451V5.32031H4.21875Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7038 7.52241L15.7925 7.89178L16.6164 7.68867C15.4306 9.41012 13.7682 11.7966 13.4063 12.2251C12.9039 12.0404 10.499 11.0244 8.88469 10.3373L8.75549 10.2819L4.97607 14.9402L5.26051 15.173L8.86967 10.7402C13.3025 12.6241 13.4097 12.6241 13.4577 12.6241C13.5759 12.6241 13.6795 12.6241 16.8083 8.06926L16.7528 8.84124L17.1222 8.86708L17.2442 7.16406L15.7038 7.52241Z",
    fill: "#737AE6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.34 10.5181L16.9742 10.5736L17.0481 11.0612L12.8481 7.55176L8.92842 13.6876L5.42283 11.2274L5.2085 11.5303L9.03198 14.2084L12.933 8.10581L16.8412 11.3678L16.2872 11.4157L16.3168 11.7851L17.5173 11.6817L17.34 10.5181Z",
    fill: "#F2CA52"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.34 10.5181L16.9742 10.5736L17.0481 11.0612L12.8481 7.55176L8.92842 13.6876L5.42283 11.2274L5.2085 11.5303L9.03198 14.2084L12.933 8.10581L16.8412 11.3678L16.2872 11.4157L16.3168 11.7851L17.5173 11.6817L17.34 10.5181Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9036 8.53881C22.1314 8.57867 21.4732 7.98476 21.4333 7.21257C21.3935 6.44038 21.9874 5.78217 22.7596 5.74231V4.38281C21.2376 4.46213 20.068 5.76013 20.1474 7.28208C20.2267 8.80402 21.5247 9.97362 23.0466 9.8943C24.4618 9.82058 25.5909 8.68704 25.6592 7.27166H24.2998C24.2312 7.99117 23.6263 8.54021 22.9036 8.53881Z",
    fill: "#737AE6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2997 7.00565H25.6592C25.5937 5.58366 24.4547 4.44631 23.0327 4.38281V5.74231C23.7047 5.802 24.238 6.33382 24.2997 7.00565Z",
    fill: "#F2CA52"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2997 7.00565H25.6592C25.5937 5.58366 24.4547 4.44631 23.0327 4.38281V5.74231C23.7047 5.802 24.238 6.33382 24.2997 7.00565Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.686 11.2871H26.3834V11.8634H19.686V11.2871Z",
    fill: "#969696"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.686 13.1191H26.3834V13.6954H19.686V13.1191Z",
    fill: "#969696"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.686 14.9512H26.3834V15.5275H19.686V14.9512Z",
    fill: "#969696"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.6838915d5a29fee27db34cc38aaeffa0.svg";
export { ForwardRef as ReactComponent };